import JoditEditor from 'jodit-react';
import { FC } from 'react';
import { CONSTANTS } from '../../constants';

const joditConfig = {
  readonly: false,
  placeholder: 'Your content here',
  cleanHTML: {
    allowTags: CONSTANTS.JODIT.ALLOWED_TAGS
  },
  style: {
    textAlign: 'left',
    height: '300px',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    overflow: 'auto',
    overflowY: 'auto',
    lineHeight: '1.5',  // Fixed line height to prevent spacing changes
  },
  askBeforePasteHTML: false,
  askBeforePasteFromWord: false,
  enter: 'p' as const,
  enterBlock: 'p' as const,
  height: 500,
  minHeight: 500,
  maxHeight: 500,
  autoHeight: false,
  // Prevent auto-formatting that causes line spacing issues
  disablePlugins: ['resizer'],
  // Prevent Jodit from reformatting on value change
  processPasteFromWord: false,
  processPasteFromWordRemoveStyles: false,
};

interface PostContentTextAreaProps {
  onChange: (content: string) => void
  value: string
}

const PostContentTextArea: FC<PostContentTextAreaProps> = (
  props: PostContentTextAreaProps,
) => {
  return (
      <JoditEditor
        value={props.value}
        onBlur={props.onChange}  // Only update on blur - no onChange handler
        config={joditConfig}
      />
  )
}

export default PostContentTextArea